
import React from 'react';
import { Popconfirm as AntdPopconfirm } from 'antd';
import { DangerFilled } from '@nackle/origami-icons';

/**
 * A Popconfirm confirmation modal
 *
 * {@link https://ant.design/components/popconfirm#api}
 *
 * @module Popconfirm
 * @param {Object} props - the pop confirm props
 * @param {Object} [props.cancelButtonProps] - the props for the cancel button
 * @param {string} [props.cancelText] - the cancel button text
 * @param {boolean} [props.disabled] - whether or not the pop confirm is disabled
 * @param {React.ReactElement} [props.icon] - the icon displayed in the pop confirm
 * @param {Object} [props.okButtonProps] - the ok button props
 * @param {string} [props.okText] - the ok button text
 * @param {string} [props.okType] - the ok button's type
 * @param {boolean} [props.showCancel] - whether or not to show the cancel button
 * @param {string} [props.title] - the title of the pop confirm
 * @param {string} [props.description] - the pop confirm description text
 * @param {Function} [props.onCancel] - the function to execute when the cancel button is clicked
 * @param {Function} [props.onConfirm] - the function to execute when the confirm (ok) button is clicked
 * @param {Function} [props.onPopupClick] - the function to execute when the popup is clicked
 * @returns {React.ReactElement} - A popconfirm component
**/
export const Popconfirm = ( { children, ...props } ) => {
    return (
        <AntdPopconfirm arrow={ { pointAtCenter: true } } { ...props } icon={ <DangerFilled /> }>
            { children }
        </AntdPopconfirm>
    );
};
